module.exports = __webpack_public_path__ + "static/media/tf.4ab43cc9.svg";